import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '@/lib/react-query';
import {
  InvoiceControllerGetChargeableServiceBookingsByCustomerV1Params,
  getSMPBackendAPIAdmin,
} from '@/proxy';
import { toBillable } from '@/services';

function getAllBillables(params: InvoiceControllerGetChargeableServiceBookingsByCustomerV1Params) {
  return getSMPBackendAPIAdmin().invoiceControllerGetChargeableServiceBookingsByCustomerV1(params);
}

export function useBillables(
  params: InvoiceControllerGetChargeableServiceBookingsByCustomerV1Params
) {
  return useQuery({
    queryKey: queryKeys.billing.billable(params),
    queryFn: () => getAllBillables(params),
    select: (data) => toBillable(data),
    enabled: !!params,
  });
}
